// AUTO-GENERATED by tools/scripts/updateVersion.js — do not edit manually
export const JMKW_VERSION: string | null = '4.1.0-rc.1';
